import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { dispatchAppError } from '../actions/core.actions';
import { findProblemImages, findProblemImagesFailure, findProblemImagesSuccess } from '../actions/kakomon-image-search.actions';
import { KakomonImageSearchService } from '../services/kakomon-image-search.service';
import { KakomonImageError } from '../errors/kakomon-image-error';

@Injectable()
export class KakomonImageSearchEffects {
  private LOG_SOURCE = this.constructor.name;

  findProblemImages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(findProblemImages),
      switchMap(action =>
        this.kakomonImageSearchService.findProblemImages(action.problemId).pipe(
          map(response => findProblemImagesSuccess({ kakomonImages: response })),
          catchError(e =>
            of(findProblemImagesFailure(), dispatchAppError({ source: this.LOG_SOURCE, error: KakomonImageError.unknown(e) }))
          )
        )
      )
    )
  );

  constructor(private actions$: Actions, private kakomonImageSearchService: KakomonImageSearchService) {}
}
